module.exports = __webpack_public_path__ + "img/eventEating2025_0318.fc300961.jpg";